import React from 'react'

const Backend = () => {
  return (
    <div className="skills__content">
      <h3 className="skills__title">Backend Development</h3>

      <div className="skills__box">
        <div className="skills__group">
          <div className="skills__data">
            <div className="skills__header">
              <i className='bx bx-badge-check'></i>
              <h3 className="skills__name">Node.js</h3>
            </div>
            <div className="skill__bar">
              <div className="skill__bar-fill intermediate"></div>
            </div>
          </div>

          <div className="skills__data">
            <div className="skills__header">
              <i className='bx bx-badge-check'></i>
              <h3 className="skills__name">Express.js</h3>
            </div>
            <div className="skill__bar">
              <div className="skill__bar-fill intermediate"></div>
            </div>
          </div>

          <div className="skills__data">
            <div className="skills__header">
              <i className='bx bx-badge-check'></i>
              <h3 className="skills__name">MongoDB</h3>
            </div>
            <div className="skill__bar">
              <div className="skill__bar-fill intermediate"></div>
            </div>
          </div>
        </div>

        <div className="skills__group">
          <div className="skills__data">
            <div className="skills__header">
              <i className='bx bx-badge-check'></i>
              <h3 className="skills__name">PostgreSQL</h3>
            </div>
            <div className="skill__bar">
              <div className="skill__bar-fill intermediate"></div>
            </div>
          </div>

          <div className="skills__data">
            <div className="skills__header">
              <i className='bx bx-badge-check'></i>
              <h3 className="skills__name">Postman</h3>
            </div>
            <div className="skill__bar">
              <div className="skill__bar-fill intermediate"></div>
            </div>
          </div>

          <div className="skills__data">
            <div className="skills__header">
              <i className='bx bx-badge-check'></i>
              <h3 className="skills__name">Django</h3>
            </div>
            <div className="skill__bar">
              <div className="skill__bar-fill basic"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Backend